import { MDBInput } from "mdb-react-ui-kit";
import { ASParamEditorProps } from "../ASParamEditor";

export const ASNumericParam = (props: ASParamEditorProps<number> & {maxValue: number}) => {

    return (
        <span style={{width: 200}}>
            <MDBInput
                type="number"
                value={props.currentValue ?? ""}
                min={0}
                max={props.maxValue}
                disabled={props.disabled}
                onChange={ev => props.onCurrentValueChange(Number(ev.currentTarget.value))}
            />
        </span>
    )
}